var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company"},[_c('div',{attrs:{"id":"company-banner"}}),_c('Introduction'),_c('Honor'),_c('History'),_c('Idea'),_c('Responsibility'),_c('HomeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }